import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
// import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router";
import { useSearchParams } from "react-router-dom";
import { useGlobalContext } from "../../../../Context/GlobalContext";
import { useAuthContext } from "../../../../Context/AuthContext";
import flowChangerLogo from "../../../../Assets/Images/flowchangerAINew.jpeg";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import { AiOutlineEye } from "react-icons/ai";
import loginSlash from "../../../../Assets/Images/login-slash.jpeg";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import loginLady from "../../../../Assets/Images/login-lady.png";
import { googleLogout, useGoogleLogin } from '@react-oauth/google';

const Step2 = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const email = searchParams.get("email");
  const [showPassword, setShowPassword] = useState(false);
  const { openToast, baseUrl } = useGlobalContext();
  const { nextStep, adminInfo, updateAdminInfo, profile } = useAuthContext();

  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const {
    getValues,
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();

  console.log(profile);
  // Set form values from adminInfo when the component mounts
  useEffect(() => {
    if (adminInfo) {
      setValue("first_name", adminInfo.first_name);
      setValue("last_name", adminInfo.last_name);
      setValue("mobile", adminInfo.mobile);
      setValue("password", adminInfo.password);
      setValue("email", adminInfo.email);
    }
  }, [adminInfo, setValue]);

  useEffect(() => {
    if (profile) {
      setValue("first_name", profile.given_name);
      setValue("last_name", profile.family_name);
    }
  }, [profile, setValue]);
  const handleInfoSubmission = async (updatedAdminInfo) => {
    console.log(updatedAdminInfo);
    const { email } = updatedAdminInfo;
    try {
      const response = await fetch(baseUrl + "admin", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...updatedAdminInfo, email: email.length > 0 ? email : profile?.email }),
      });

      console.log(response);
      const result = await response.json()
      // console.log(result, "hsdkhfashoi")

      if (response.status === 201) {
        nextStep();
        setSearchParams({ step: 3, email: updatedAdminInfo?.email });
      } else {
        // const result = await response.json();
        // console.log(result.message);
        openToast(result.message || "Internal server error", "error");
      }
    } catch (error) {
      console.log(error);
      openToast("Error while submitting data:", error);
    }
  };

  const onSubmit = async (data) => {
    const { terms, ...userInfo } = data;
    const updatedAdminInfo = { ...adminInfo, ...userInfo };
    console.log(adminInfo, "----------------", userInfo)
    updateAdminInfo(updatedAdminInfo);
    console.log(updatedAdminInfo);
    try {
      setIsLoading(true);
      await handleInfoSubmission(updatedAdminInfo);
    } catch (error) {
      console.error("Error during form submission:", error);
    } finally {
      setIsLoading(false);
    }
  };

  console.log(getValues());
  return (
    <>
      <style>
        {`
      .react-tel-input .flag-dropdown .selected-flag,
      .react-tel-input .flag-dropdown .country-list .country {
        padding-left: 8px !important;
      }
      .react-tel-input .flag-dropdown .selected-flag .flag,
      .react-tel-input .flag-dropdown .country-list .country .flag {
        display: none !important;
      }
      .react-tel-input .country-list .country {
        display: flex;
        justify-content: space-between;
        padding-right: 8px !important;
      }
      .react-tel-input .country-list .country-name {
        margin-right: 8px;
      }
      .react-tel-input .country-list .dial-code {
        color: #666;
      }
    `}
      </style>
      <div className="flex justify-center items-center px-[10px] md:px-[20px] lg:px-[20px] xl:px-[20px] py-[10px] md:py-[20px] lg:py-[20px] xl:py-[20px] rounded-lg h-screen overflow-y-auto">
        <div
          className="flex justify-center bg-white rounded-lg w-[100%] lg:w-[100%] xl:w-[80%] login-div"
        >
          <div className="px-6 md:px-2 lg:px-[62px] xl:px-[30px] pt-[20px] pb-[10px] w-full md:w-1/2">
            <div className="flex justify-center items-center">
              <img src={flowChangerLogo} className="w-[120px]" />
            </div>
            <div className="">
              <form className="mt-4 ml-0" onSubmit={handleSubmit(onSubmit)}>
                <div className="flex flex-col gap-[14px] w-full">
                  <div className="flex md:flex-row flex-col justify-between items-center gap-[10px] w-full">
                    <div className="w-full md:w-1/2">
                      <label htmlFor="first_name" className="ml-2 text-[#706b6b]">
                        First Name
                      </label>

                      <input
                        value={getValues("first_name")}
                        type="text"
                        id="first_name"
                        placeholder="First Name"
                        aria-label="first_name"
                        className="login-input-field"
                        {...register("first_name", {
                          required: "First Name is required",
                        })}
                      />
                      {errors.first_name && (
                        <p className="ml-2 text-red-500 text-xs">
                          {errors.first_name.message}
                        </p>
                      )}
                    </div>
                    <div className="w-full md:w-1/2">
                      <label htmlFor="last_name" className="ml-2 text-[#706b6b]">
                        Last Name
                      </label>
                      <input
                        value={getValues("last_name")}
                        type="text"
                        id="last_name"
                        placeholder="Last Name"
                        aria-label="last_name"
                        className="login-input-field"
                        {...register("last_name", {
                          required: "Last Name is required",
                        })}
                      />
                      {errors.last_name && (
                        <p className="ml-2 text-red-500 text-xs">
                          {errors.last_name.message}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="flex md:flex-row flex-col justify-between items-center gap-[10px] w-full">
                    <div className="w-full md:w-1/2 mobile-input">
                      <label htmlFor="mobile" className="ml-2 text-[#706b6b]">
                        Mobile No.
                      </label>
                      <PhoneInput
                        placeholder="Enter phone number"
                        country={"us"}
                        enableSearch
                        inputProps={{
                          name: "mobile",
                          id: "mobile",
                          required: true,
                        }}
                        inputClassName="bg-transparent"
                        disableSearchIcon={true}
                        countryCodeEditable={false}
                        buttonClass="border rounded-l-md"
                        containerClass="phone-input-container rounded-full"
                        inputClass="login-input-field"
                        onChange={(value) => {
                          // Update the value in react-hook-form
                          setValue("mobile", value, { shouldValidate: true });
                        }}
                        style={{
                          border: '1px solid #ccc',
                          borderRadius: '9999px',
                          padding: '8px 15px',
                        }}
                      />
                      {errors.mobile && (
                        <p className="ml-2 text-red-500 text-xs">
                          {errors.mobile.message}
                        </p>
                      )}
                    </div>
                    <div className="w-full md:w-1/2">
                      <label htmlFor="password" className="ml-2 text-[#706b6b]">
                        Password
                      </label>
                      <div className="relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          id="password"
                          placeholder="Enter a password"
                          aria-label="password"
                          className="login-input-field"
                          {...register("password", {
                            required: "Create your password",
                          })}
                        />
                        <button
                          type="button"
                          onClick={() => setShowPassword(!showPassword)}
                          className="top-1/2 right-3 absolute text-[#8a25b0] hover:text-purple-700 -translate-y-1/2 transform"
                        >
                          {showPassword ? (
                            <AiOutlineEye size={20} />
                          ) : (
                            <AiOutlineEyeInvisible size={20} />
                          )}
                        </button>
                      </div>
                      {errors.password && (
                        <p className="ml-2 text-red-500 text-xs">
                          {errors.password.message}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mt-2 mb-6 ml-1">
                  <div className="flex items-center">
                    <input
                      type="checkbox"
                      id="checkbox"
                      style={{
                        width: "1em",
                        height: "1.3em",
                        borderRadius: "100%",
                      }}
                      aria-label="checkbox"
                      className="bg-slate-100 py-3 focus:outline-none w-[30px] accent-[#8a25b0] login-input-field"
                      {...register("terms", {
                        required: "You must agree to the terms",
                      })}
                    />
                    <label htmlFor="checkbox" className="ml-2 text-[#706b6b]">
                      I agree with the Terms and Privacy Policy
                    </label>
                  </div>
                  {errors.terms && (
                    <p className="ml-6 text-red-500 text-xs">
                      {errors.terms.message}
                    </p>
                  )}
                </div>
                {/* Next step button */}
                <button
                  type="submit"
                  className={`w-full font-medium bg-[#8a25b0] rounded-full text-white py-2 px-4 hover:bg-[#884a9f] transition duration-300  mb-3 ${isLoading ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  disabled={isLoading}
                >
                  Next
                </button>
              </form>
            </div>
          </div>

          <div className="hidden login-right relative md:flex justify-center items-center bg-[#9181F4] px-[30px] py-[10px] w-[50%] md:w-[50%] lg:w-[50%] xl:w-[50%] text-4xl text-center">
            <div className="relative bg-[#e2e0e938] border border-[#bfbfbf66] rounded-xl w-[80%] h-[83%]">
              <h2 className="p-[18px] w-[212px] font-bold text-[32px] text-white md:text-[22px] text-left">
                Start your journey now by creating an account.!!!
              </h2>
              <div className="top-[-6px] right-[-30px] bottom-0 absolute h-[288px]">
                <img src={loginLady} alt="loginLady" className="h-[100%]" />
              </div>
              <div className="left-[-20px] absolute bg-white p-[10px] rounded-full">
                <img src={loginSlash} alt="loginSlash" className="rounded-full" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Step2;
